var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1369,
    height: 361,
    viewBox: "0 0 1369 361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(0,0,0,0)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1369,
    height: 361,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1368,
    height: 360,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0,64,.5q-9.3,1.7-14,8-7.2,6.8-5,23Q47.8,41.2,55.5,46l11,4h7Q86.3,47.8,92,38.5q4.4-5.6,4-16l-3-10L86.5,5,76,.5,231.5,0V1Q220.8,3.3,216,11.5q-4.8,6.2-3,19,2.4,9.6,9.5,14.5,6.5,5.5,19,5Q252,48,258,41.5q6.8-6.7,6-21Q261.6,9.4,253.5,4L245,.5,1369,0V257.5l-3.5.5-1,1h-11q-6.6-.9-9.5-5.5l-3-8V90h-45.5l-.5.5v165l5,20a41.3,41.3,0,0,0,11.5,14.5l17,8,12,1,1,1h13l1-1q8.6.8,13.5-1v62.5l-.5.5h-576v-1l16-1,16-5A75.837,75.837,0,0,0,853,333.5a52.438,52.438,0,0,0,10-18l5-23V146H823v16.5l-2-1-7.5-8.5a48.188,48.188,0,0,0-19-8q-4.7,1.3-6-1h-21l-14,3-12,5L721,168.5q-10.9,11.6-16,29l-3,16v15l3,16,8,18L729.5,281a70.731,70.731,0,0,0,25,13l17,3h13l1-1h8l14-4a34.561,34.561,0,0,0,16-11l.5,6.5-3,13a28.907,28.907,0,0,1-9.5,12.5q-13.7,9.8-39,8l-18-4-21-10L712,337.5v2l5.5,4.5,22,10,21,5,19.5,1.5-605.5.5v-1l19-2,31-10A139.724,139.724,0,0,0,270,315.5q26.8-28.2,36-74l1-12,1-1v-11l1-1V90H.5L0,89.5ZM656,84l-12,5q-7,5-10,15-2,15,5,22,6,7,17,9,15,1,22-6,6-5,8-14V105l-5-11-12-9Zm255,0-12,5q-8,5-10,16-2,14,5,21,6,6,17,9,15,1,22-6,6-5,8-14V105l-5-11-12-9ZM420,90V296h93l1-1,16-1,17-4,13-5,20-13a95.915,95.915,0,0,0,25-35l4-12,2-10v-7l1-1V180l-3-17q-6-22-18-36-19-26-55-34l-10-2h-8l-1-1Zm611,52-22,5a85.33,85.33,0,0,0-26,16,73.367,73.367,0,0,0-20,27l-4,12-1,12-1,1,1,21,5,17a79.173,79.173,0,0,0,16,23,75.662,75.662,0,0,0,24,16l18,6,14,1,1,1,20-1,19-5a90.479,90.479,0,0,0,28-19l1-2,1-1-27-28h-2a43.942,43.942,0,0,1-17,12l-12,3q-20,1-29-8-12-8-15-25l1-14q3-11,9-17,7-9,21-12,14-2,24,2a64.053,64.053,0,0,1,19,13l10-9,4-5,3-2,11-12q-13-16-34-24l-18-4Zm153,1-15,3-11,4-23,15-13,18-5,12-3,14v27l2,10a67.678,67.678,0,0,0,12,24l20,17,17,8,19,4h26l15-3q22-7,37-22l1-2-26-25q-11,10-28,14-28,3-40-9l-6-6-4-12,115-1v-6l1-1V214l-1-1v-8l-2-9a70.941,70.941,0,0,0-15-27,67.721,67.721,0,0,0-28-21l-20-5Zm-547,3V296h46V146Zm255,0V296h46V146Z",
    fill: "rgba(0,0,0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M468,132h40.5l1,1,13,1q20.1,4.4,30.5,18.5l6,10,4,12,2,21-1,1-1,16-3,9A42.25,42.25,0,0,1,545.5,241l-12,7-19,5L468,254Z",
    fill: "rgba(0,0,0,0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62,155H245.5l.5.5v60l-4,21-5,13A75.535,75.535,0,0,1,216.5,275a78.641,78.641,0,0,1-27,14l-20,4-18,1-1-1-18-1-21-6A76.841,76.841,0,0,1,80,262.5q-11.7-14.8-16-37l-1-15-1-1Z",
    fill: "rgba(0,0,0,0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.5,180q24.6-1.6,34.5,11.5,4.8,4.3,4,12.5h-67.5l-.5-1.5a28.474,28.474,0,0,1,9.5-14.5Q1177.5,182,1189.5,180Z",
    fill: "rgba(0,0,0,0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5,185q12.1-1.6,20,1A44.47,44.47,0,0,1,817,198.5l7,12q2.3,6.7,1,17-2.9,13.6-12.5,20.5l-15,8q-7.1,2.4-18,1-16.3-3.2-24.5-14.5-7.9-8.6-7-26,2.9-15.6,13.5-23.5Q768.1,187.1,778.5,185Z",
    fill: "rgba(0,0,0,0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M.5,225,5,253.5l8,23Q26.8,306.7,50.5,327a138.982,138.982,0,0,0,38,23l22,7,23.5,3.5L0,361Z",
    fill: "rgba(0,0,0,0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5,1q10.1-1.6,16,1L91,11.5l4,10v7Q92.6,38.6,85.5,44l-11,5h-9Q56.1,46.9,51,40.5q-6.1-5.9-6-18Q47,10.5,55.5,5Z",
    fill: "#f60014"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M232.5,1h12L256,7l6,9.5,1,13Q260.3,39.8,252.5,45l-10,4h-9l-6-2L220,42l-6-11.5v-12A25.734,25.734,0,0,1,223.5,5Z",
    fill: "#f60014"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M654.5,85q20-1.5,26.5,10.5l4,9v10q-2.7,10.3-10.5,15.5l-10,4h-9q-11.9-2.6-17.5-11.5-4.8-6.2-3-19,2.8-9.7,10.5-14.5Z",
    fill: "#f60014"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M909.5,85q20-1.5,26.5,10.5,5.7,6.3,4,20A28.688,28.688,0,0,1,929.5,130l-10,4h-9q-11.1-2.4-16.5-10.5-6-6-4-20A28.688,28.688,0,0,1,900.5,89Z",
    fill: "#f60014"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0,90H308V219.5l-1,1v9l-3,17-9,28q-13.3,31.2-37.5,51.5-21.4,18.6-52,28l-30,6-30,1-1-1h-12l-1-1-17-2-28-9Q57.4,335.6,38,313.5q-26.2-28.3-35-74l-1-12-1-1v-12l-1-1Zm62,64v65q3,1,1,7,5,25,19,41a77.645,77.645,0,0,0,25,18l17,6,17,3h28l17-3q21-5,35-18a97.994,97.994,0,0,0,17-23l6-17,2-10v-8l1-1V154Z",
    fill: "#f60014"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M421,90h83.5l1,1h13l1,1h7l10,2,13,4,15,7A95.215,95.215,0,0,1,588,124.5q14,15,20,38l3,16v30l-3,16-4,12A96.159,96.159,0,0,1,581.5,269a92.929,92.929,0,0,1-27,17l-15,5-15,3h-9l-1,1H421Zm46,41V254h46q1-2,7-1l14-4,16-10,10-14,5-19q3-38-13-56l-9-9-10-5-10-3-14-1-1-1Z",
    fill: "#f60014"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1296,90h43.5l.5.5v155q1.5,8.5,7.5,12.5l7,2h8l5.5-1v37.5l-1.5.5-8,2h-19l-15-3a42.522,42.522,0,0,1-16.5-10.5l-7-10-5-18Z",
    fill: "#f60014"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.5,143h25l17,4q20.2,7.8,33.5,22.5l-3.5,4.5-24,23a44.068,44.068,0,0,0-19-13l-8-2h-16q-15.5,3.5-23.5,14.5-8.5,9.5-8,28l3,12,9.5,13.5a40.776,40.776,0,0,0,17,9l14,1,13-3a50.2,50.2,0,0,0,18-12l27.5,26.5a79.215,79.215,0,0,1-29.5,21.5l-18,5-24,1-16-3-14-5A82.807,82.807,0,0,1,975,269.5a79.859,79.859,0,0,1-15-29l-2-11v-17l3-15,5-12A81.28,81.28,0,0,1,986.5,161l20-12Z",
    fill: "#f60014"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.5,143l22,2,13,4a77.195,77.195,0,0,1,25.5,17.5,74.623,74.623,0,0,1,17,29l3,15v19l-1,2.5H1159.5q-1.2.3-.5,6.5a30.067,30.067,0,0,0,10.5,15.5q12.7,9.8,37,8l15-4,15-10,25.5,23.5a81.6,81.6,0,0,1-31.5,21.5l-20,5-18,1-1-1-16-1-14-4q-19.4-7.6-31.5-22.5a62.06,62.06,0,0,1-13-25l-2-9v-8l-1-1v-12l1-1v-8l2-9,8-18,16.5-18.5a71.935,71.935,0,0,1,21-12l19-5h11Zm-2.5,36-12,3-8,4a28.776,28.776,0,0,0-12,17l1,1h69q1-7-3-11Q1216,178,1191,179Z",
    fill: "#f60014"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M766.5,145q37-3.5,52.5,14.5l3.5,5.5.5-18h44.5l.5.5v134l-1,1v11l-1,1-1,11-5,15A59.99,59.99,0,0,1,841.5,343a82.322,82.322,0,0,1-25,13l-22,4h-19l-1-1-15-1-20-5L713,340l1-3.5L733.5,308l13,7,11,4,17,3h12l18-4,11.5-7.5,7-13,2-18.5-11.5,9-15,6-11,1-1,1h-17l-21-5A77.372,77.372,0,0,1,722,272.5a74.116,74.116,0,0,1-16-28l-3-15v-17l3-15,7-16A73.82,73.82,0,0,1,731.5,160Q745.2,148.7,766.5,145ZM779,184q-10,2-16,7l-10,10-4,8-2,9,1,13,5,11q9,13,28,16l17-1,14-7q11-7,14-22V215l-6-14a43.678,43.678,0,0,0-18-15l-8-2Z",
    fill: "#f60014"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M638,147h43.5l.5.5V295H638.5l-.5-.5Z",
    fill: "#f60014"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M893,147h43.5l.5.5V295H893.5l-.5-.5Z",
    fill: "#f60014"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5,1l1.5.5L54.5,6l2-3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5,1,85,4.5,83.5,4l-5-2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M226.5,2l1.5.5L225.5,4Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M251.5,3l8.5,7.5,1,2-2-1L253.5,5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M223.5,4,217,11.5,214.5,17l-.5-1.5A23.188,23.188,0,0,1,223.5,4Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,5l3,4Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5,6l-2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5,10l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5,10,94,15.5H93Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M261.5,14l1.5,4.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M213.5,18l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M263.5,20l.5,8.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5,22l.5,5.5H95Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M213.5,28l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5,30l.5,2.5L93.5,35,93,33.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5,33a20.776,20.776,0,0,0,9,12L58,46.5,56.5,46,48,38.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M261.5,34l.5,1.5L258.5,40l1.5-2.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5,38l-7,8-2,1,1-2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M217.5,39l5,6Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M257.5,41l-2,3-3,2,2-3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5,45l4.5,2.5-1.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5,47l1.5.5L76.5,49V48Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5,49l7.5.5-7.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M234.5,49l7.5.5-7.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M655.5,84l9.5.5-9.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5,84l9.5.5-9.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M648.5,86l1.5.5L639.5,94l4-5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M903.5,86l1.5.5L894.5,94l4-5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M674.5,88l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M929.5,88l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M308.5,90l.5,126.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M420.5,90l.5,205,92,.5-93,.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M511.5,90l5.5.5-5.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M677.5,90l6.5,9.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M932.5,90a21.185,21.185,0,0,1,7.5,11.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1295.5,90l.5,165.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.5,90l.5,152.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M521.5,91l4.5.5-4.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M528.5,92l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M533.5,93l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M541.5,95l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M638.5,95l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M893.5,95l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M553.5,99l3.5,1.5-1.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M562.5,103l5.5,3.5-1.5-.5Q562.5,105.5,562.5,103Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M634.5,103l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M685.5,104l.5,4.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M889.5,104l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M940.5,104l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M569.5,107l5.5,4.5-2.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M685.5,111l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M940.5,111l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M576.5,112l14,15Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M634.5,112l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M889.5,112l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M684.5,117l.5,1.5L677.5,129l2.5-3.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M939.5,117l.5,1.5L932.5,129l2.5-3.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M637.5,122l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M892.5,122l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M639.5,125l6.5,5.5-1.5-.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M894.5,125l3,4Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M591.5,128l2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M675.5,129l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M899.5,129l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M930.5,129l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M467,131l35,.5-34,.5-.5,122Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M509.5,132l5.5.5-5.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M594.5,132l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M517.5,133l3.5.5-3.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M666.5,133l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M655.5,134l9.5.5-9.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M910.5,134l9.5.5-9.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M596.5,135l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M535.5,138l2.5,1.5-1.5-.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M599.5,140l3.5,6.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M541.5,141l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.5,142l4.5.5-4.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.5,142l5.5.5-5.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M544.5,143l8,9Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.5,143l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.5,143l3.5.5-3.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.5,143l4.5.5-4.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1204.5,143l4.5.5-4.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M767.5,144l5.5.5-5.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M783.5,144l5.5.5-5.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.5,144l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.5,144l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.5,144l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.5,144l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M761.5,145l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M791.5,145l3.5.5-3.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.5,145l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.5,145l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.5,145l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M637,146l46,.5-45,.5V294.5l.5.5h44v1h-45l-.5-.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M796.5,146l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M823.5,146l44.5.5-44.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M892,146l46,.5-45,.5V294.5l.5.5h44v1h-45l-.5-.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.5,147l1.5.5-3.5,1.5v-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M750.5,148l1.5.5-3.5,1.5v-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M803.5,148l8.5,4.5-1.5-.5-7-3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.5,148l3.5,1.5-1.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.5,151l-1,2-2,1,1-2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M605.5,152l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M741.5,152l1.5.5-2.5,1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M553.5,153l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M813.5,153l7,8Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M996.5,153l-1,2-6,4,2-3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.5,153l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M1238.5,153l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5,154h183l1.5,1.5-.5,52.5-.5-53H62.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M738.5,154l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.5,155l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.5,155l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.5,155l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M555.5,156l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M735.5,156l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.5,157l13.5,12.5L1093.5,182l10.5-11.5-8.5-9.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.5,157l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.5,157l2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M732.5,158l-3,4Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M987.5,159l-3,4Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.5,159l-3,4Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1249.5,161l7,8Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M608.5,162l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M727.5,162l-5.5,6.5-6.5,8.5,1.5-2.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M821.5,162l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M982.5,163l-6,7Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M609.5,166l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M561.5,168l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M1131.5,170l-3,4Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M610.5,171l.5,4.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M975.5,171l-3,4Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M1258.5,171l2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.5,175l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.5,175l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M563.5,176l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M971.5,176l-1.5,2.5-1.5,2.5.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M714.5,178l-.5,1.5-1.5,2.5.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1125.5,178l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1263.5,178l2.5,3.5-2-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M611.5,179l.5,6.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.5,179l6.5.5-6.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.5,180l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M1203.5,180l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.5,181l-.5,1.5-.5,1.5-.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M1207.5,181l4.5,1.5-1.5.5-3-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M967.5,182l-.5,1.5-3.5,7.5-.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.5,182l12.5.5-12.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M564.5,183l.5,6.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M711.5,183l-.5,1.5-.5,1.5-.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.5,183l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.5,183l1.5.5-4.5,2.5,1-2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M780.5,184l11.5.5-11.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.5,184l-4,5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M775.5,185l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.5,185l2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M799.5,186l3.5,1.5-1.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.5,186l4.5,2.5-1.5-.5Q1059.8,187.8,1060.5,186Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1171.5,186l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.5,187l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M1268.5,187l1.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.5,188l-3.5,4.5-4.5,9.5-.5-2.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.5,188l2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M806.5,189l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.5,189l-2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.5,189l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.5,189l-8,9-1-2,1,1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.5,189l.5,1.5-1.5,2.5-.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M764.5,190l-2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M809.5,191l2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.5,191l4,5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.5,192l-1.5,2.5-3.5,4.5,2.5-3.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1224.5,192l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M760.5,193l-4.5,5.5-2.5,3.5,1.5-2.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M813.5,194l3,4Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M1271.5,195l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M564.5,196l.5,7.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M960.5,197l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M817.5,199l2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.5,199l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M1228.5,200l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M611.5,201l.5,5.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M704.5,201l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M959.5,201l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.5,202l-.5,1.5-.5,1.5-.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M752.5,203l-.5,1.5-1.5,3.5-.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M820.5,203l3.5,6.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.5,204l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M703.5,205l.5,4.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M958.5,206l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.5,206l.5,1.5-1.5,3.5-.5-2.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M563.5,207l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.5,208l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5,210l.5,6.5H62Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M610.5,211l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M824.5,211l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.5,212l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M702.5,213l.5,15.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M748.5,213l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M1274.5,213l.5,12.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M957.5,214l.5,13.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M245.5,216l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M561.5,216l.5,2.5-1.5,2.5-.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M825.5,216l.5,9.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M609.5,217l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5,220l.5,4.5H63Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M.5,222l.5,2.5H0Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M559.5,222l.5,1.5-3.5,5.5.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M608.5,222l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M307.5,223l.5,5.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M244.5,224l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5,226l.5,2.5H64Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M748.5,226l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.5,226l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M824.5,228l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5,229l.5,3.5H1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M243.5,229l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M555.5,230l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5,231l.5,2.5H65Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.5,231l.5,4.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M306.5,232l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M958.5,232l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M553.5,233l-7,8Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M703.5,233l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M750.5,234l2.5,4.5-2-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.5,234l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M604.5,235l.5,1.5-1.5,2.5-.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5,236l.5,3.5H2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M821.5,237l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M704.5,238l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M305.5,239l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.5,239l2.5,3.5-2-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M753.5,240l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M819.5,240l-1.5,2.5-4.5,5.5,3.5-4.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5,241l1.5,3.5H69Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M544.5,241l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5,242l.5,2.5H3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M541.5,243l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M755.5,243l5,6Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M1116.5,243l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M304.5,244l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.5,244l12.5,10.5-1.5-.5Q1013.5,250.8,1010.5,244Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.5,244l-4,5-6,4,1-2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.5,244l22,23Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M238.5,245l.5,1.5-1.5,2.5-.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.5,246l2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M1341.5,246l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.5,247l2.5,1.5-1.5-.5-4,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5,248l1.5,2.5-2-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M303.5,248l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M598.5,248l-.5,1.5-1.5,2.5.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M811.5,248l-2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M707.5,249l1.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M762.5,249l4.5,3.5-1.5-.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M236.5,250l-.5,1.5-2.5,4.5.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M524.5,250l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M1342.5,250l1.5,2.5-2-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5,251l.5,2.5H5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M520.5,251l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M807.5,251l-1,2-5,2v-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M963.5,251l4.5,8.5-2-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M1230.5,251l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M302.5,252l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M515.5,252l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M1169.5,252l2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M1242.5,252l10,11Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M503.5,253l6.5.5-6.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M595.5,253l-2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.5,253l-1,2-3,1v-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.5,253l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5,254l5.5,7.5-3-2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M1344.5,254l2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M776.5,256l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M232.5,257l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M592.5,257l-2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M782.5,257l7.5.5-7.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.5,257l2.5,4.5-2-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M1219.5,257l1.5.5-3.5,1.5v-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M1348.5,257l4.5,1.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.5,258l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.5,258l3.5.5-3.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M1365.5,258l3.5.5-3.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.5,259l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M230.5,260l-1.5,2.5L216.5,276l-3,2,2-3L228,263.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5,260l3.5,4.5-3-2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.5,260l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M1209.5,260l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.5,260l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M589.5,261l-10,11Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M968.5,261l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.5,261l11.5.5-11.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5,263l11,12Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.5,263l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M970.5,264l2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M716.5,266,730,280.5l-12-11Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.5,266l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M1257.5,266l5.5,6.5-2,1,1-2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M973.5,268l5,6Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.5,269l3,4Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,270l1.5,3.5H12Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M296.5,271l.5,1.5-1.5,2.5-.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M577.5,272l-3,4Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.5,273l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M1300.5,274l1.5,2.5-2-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,275,21,289.5l-2-1-6-12Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5,275l5.5,4.5L96.5,278Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M979.5,275l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M572.5,276l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M1257.5,276l-3,4Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M982.5,277l8.5,7.5-2.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5,278l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M293.5,278l.5,1.5-5.5,9.5.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M569.5,278l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.5,278l-3,4Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.5,279l2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M208.5,280l-1,2-9,4v-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M823.5,280l-5,6Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M1252.5,280l-2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M1303.5,280l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M102.5,281l6.5,3.5-1.5.5Q102.9,283.8,102.5,281Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M731.5,281l7.5,5.5-1.5-.5Q732.5,284.5,731.5,281Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M560.5,283l-1,2-1.5-.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.5,283l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.5,283l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M1305.5,283l6,7Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M992.5,285l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.5,285l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.5,285l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.5,285l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M112.5,286l3.5,1.5-1.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M195.5,286l1.5.5-3.5,1.5v-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M816.5,286l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M867.5,286l.5,6.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.5,287l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5,288l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M823.5,288l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M997.5,288l6.5,3.5-1.5.5Q997.9,290.8,997.5,288Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M544.5,289l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M124.5,290l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M182.5,290l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M287.5,290l-.5,1.5-1.5,2.5.5-1.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M746.5,290l3.5,1.5-1.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M1313.5,290l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M129.5,291l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M177.5,291l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M537.5,291l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M134.5,292l4.5.5-4.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M170.5,292l4.5.5-4.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M532.5,292l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.5,292l1.5.5-3.5,1.5v-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,293l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5,293l8.5.5-8.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M157.5,293l8.5.5-8.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M527.5,293l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M518.5,294l4.5.5-4.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M758.5,294l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M822.5,294l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.5,294l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M284.5,295l-.5,1.5-4.5,6.5,1.5-2.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M763.5,295l3.5.5-3.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M789.5,295l4.5.5-4.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M1222.5,295l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,296l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M771.5,296l13.5.5-13.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5,296l.5,3.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.5,296l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.5,296l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M1171.5,296l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.5,296l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5,297l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.5,297l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.5,297l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.5,297l3.5.5-3.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.5,297l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.5,298l3.5.5-3.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.5,298l3.5.5-3.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.5,298l4.5.5-4.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M1206.5,298l3.5.5-3.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M1333.5,298l3.5.5-3.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M1361.5,298l3.5.5-3.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5,299l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.5,299l11.5.5-11.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M1341.5,299l13.5.5-13.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5,302l2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M865.5,302l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M278.5,304l-2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M818.5,305l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5,306l3,4Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M733.5,307l2.5,1.5-1.5-.5-3.5,2.5L720.5,326l1.5-2.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M864.5,307l.5,2.5h-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M275.5,308l-5.5,6.5-7.5,8.5,6.5-7.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M816.5,308l-5,6-2,1,1-2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5,311l15,16Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M750.5,315l3.5,1.5-1.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M763.5,319l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M795.5,319l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M860.5,319l.5,1.5L853.5,332l1.5-2.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M767.5,320l4.5.5-4.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M789.5,320l3.5.5-3.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M776.5,321l6.5.5-6.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M260.5,323l-5,6Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5,327l3,4Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M719.5,327l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M253.5,329l-2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M717.5,330l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5,331l2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M249.5,332l-2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M715.5,333l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M852.5,333l-8,9Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5,334l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M245.5,335l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5,336l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M713.5,336l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M242.5,337l-1,2-2,1,1-2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5,338l3.5,2.5-1.5-.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M237.5,340l-1,2-13,6v-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M713.5,340l1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5,342l6.5,3.5-1.5.5Q74.9,344.8,74.5,342Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M716.5,342l7.5,4.5-1.5-.5Q716.9,345.2,716.5,342Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M842.5,342l-2,3Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M838.5,345l-1,2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M835.5,347l-1,2-2,1,1-2Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,348l3.5,1.5-1.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M218.5,349l1.5.5-3.5,1.5v-1Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5,351l3.5,1.5-1.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M734.5,351l3.5,1.5-1.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5,353l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M739.5,353l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M203.5,354l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M106.5,355l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5,356l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M814.5,356l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M115.5,357l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M191.5,357l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M754.5,357l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M120.5,358l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M185.5,358l3.5.5-3.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M760.5,358l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M805.5,358l3.5.5-3.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M126.5,359l3.5.5-3.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M179.5,359l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M767.5,359l4.5.5-4.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M798.5,359l4.5.5-4.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M134.5,360l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M171.5,360l2.5.5-2.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M780.5,360l11.5.5-11.5.5Z",
    fill: "rgba(252,153,161,0.33)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5,0,75,.5,66.5,1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M234.5,0l8.5.5-8.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5,5l4,5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M253.5,5l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5,6l-3,4Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M256.5,8l2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M213.5,22l.5,5.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5,37l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5,38l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M217.5,38l2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M257.5,40l-2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5,42l2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M505.5,90l5.5.5-5.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M643.5,90l-4,5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M676.5,90l3,4Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M898.5,90l-4,5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M931.5,90l3,4Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M893.5,96l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M568.5,107l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M634.5,107l.5,4.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M889.5,107l.5,4.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M940.5,108l.5,2.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M575.5,112l3,4Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M892.5,121l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M639.5,124l4,5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M894.5,124l4,5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M588.5,125l2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M679.5,125l-3,4Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M934.5,125l-3,4Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M592.5,130l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M502.5,131l5.5.5-5.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M596.5,136l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M542.5,141l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.5,142l11.5.5-11.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.5,143l4.5.5-4.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M1200.5,143l3.5.5-3.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M546.5,144l5,6Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M773.5,144l9.5.5-9.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M682.5,147l.5,147.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M937.5,147l.5,147.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M553.5,152l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M812.5,153l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.5,153l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M555.5,155l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.5,155l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.5,157l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M1243.5,157l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M733.5,158l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M988.5,159l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.5,159l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M819.5,160l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M1247.5,160l2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.5,161l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M728.5,162l-6,7Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M821.5,163l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M983.5,163l-7,8Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.5,163l-6,7Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M1254.5,167l3,4Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.5,173l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M1259.5,173l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M973.5,174l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.5,174l-14,15Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M716.5,176l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.5,179l2.5.5-2.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M611.5,186l.5,14.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.5,186l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M1219.5,186l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.5,187l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M807.5,189l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.5,189l-2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.5,189l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M762.5,191l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M810.5,191l2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M1224.5,191l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.5,192l3,4Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.5,195l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M817.5,198l2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M754.5,199l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M820.5,202l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M246.5,208l.5,5.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.5,212l.5,2.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M.5,214l.5,7.5H0Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M747.5,217l.5,7.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.5,217l.5,7.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M245.5,220l.5,2.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M307.5,220l.5,2.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.5,228l.5,2.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M703.5,230l.5,2.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.5,230l.5,1.5-1.5,1.5h-113v-1h113Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M551.5,236l-2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M751.5,238l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M821.5,238l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M545.5,241l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M753.5,241l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M819.5,241l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M542.5,243l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.5,243l.5,2.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.5,244l7,8-7-7-1.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M598.5,247l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.5,247l2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M812.5,248l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.5,248l5,6Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M761.5,249l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.5,249l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M1238.5,249l6,7Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M595.5,252l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M510.5,253l2.5.5-2.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M592.5,256l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M790.5,257l2.5.5-2.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M232.5,258l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5,259l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.5,259l8.5.5-8.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M1354.5,259l8.5.5-8.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M1368.5,259l.5,37.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M589.5,260l-4,5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M968.5,260l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5,261l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.5,261l2.5.5-2.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M1253.5,263l6,7Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M716.5,265l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5,266l6,7Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M226.5,266l-6,7Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M973.5,267l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.5,267l3,4Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.5,268l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5,269l-2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M719.5,269l2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.5,272l-5,6Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.5,272l-3,4Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.5,273l5,6Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M574.5,274l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M979.5,274l2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5,275l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M571.5,276l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M727.5,277l3,4Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M568.5,278l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M823.5,279q2.8-.6,1.5,5.5h-1l-.5-4.5-6.5,5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M986.5,280l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.5,280l-2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M732.5,281l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.5,281l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M867.5,282l.5,3.5h-1Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M1249.5,282l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M1305.5,282l2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M990.5,283l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M993.5,285l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M815.5,286l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.5,287l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.5,287l2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,292l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M166.5,293l2.5.5-2.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M515.5,294l2.5.5-2.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.5,298l3.5.5-3.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M1202.5,298l3.5.5-3.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5,301l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M278.5,303l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5,305l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M818.5,306l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M275.5,307l-3,4Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5,310l2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M815.5,310l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M268.5,315l-7,8Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M783.5,321l3.5.5-3.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5,324l2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M721.5,325l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M256.5,326l-2,3Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M719.5,328l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5,329l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M251.5,330l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M717.5,331l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5,332l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M852.5,332l-9,10Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M247.5,333l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5,334l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M715.5,334l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M244.5,335l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M713.5,337l-.5,1.5-.5,1.5-.5-1.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M714.5,340l1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M840.5,343l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M837.5,345l-1,2Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M176.5,359l2.5.5-2.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M772.5,359l2.5.5-2.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M795.5,359l2.5.5-2.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5,360l7.5.5-7.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M164.5,360l6.5.5-6.5.5Z",
    fill: "rgba(246,19,38,0.87)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.680c89aa10d281502345dc426b4ca379.svg";
export { ForwardRef as ReactComponent };